module.exports = __webpack_public_path__ + "static/img/female-1.35edf854.png";